//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: {
        layout: {
            type: String,
            default: 'default'
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        },
        websiteName: function websiteName() {
            var displayName = global.websiteSettings.extra_info.display_name;
            if (displayName) {
                return this.$root.trans('st_public.' + displayName);
            }
            return '';
        }
    },
    methods: {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FeaturedOn.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FeaturedOn.vue
// module chunks = 9 11